import { Component, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { PixelService } from '../../services/pixel.service';
import { PresaleDataService } from '../../services/connection-services/data.service';

@Component({
  selector: 'app-tokenomics',
  standalone: false,
  templateUrl: './tokenomics.component.html',
  styleUrl: './tokenomics.component.scss',
})
export class TokenomicsComponent {
  currentLanguage = '';
  salePrice: number = 0;

  private readonly translate = inject(TranslateService);
  private readonly pixelService = inject(PixelService);
  private readonly dataService = inject(PresaleDataService);
  
  // Asset image URLs
  iconGovernance = '/assets/images/svg-icons/governance.svg';
  iconYield = '/assets/images/svg-icons/yield-distribution.svg';
  iconFee = '/assets/images/svg-icons/fee-discounts.svg';
  iconBurn = '/assets/images/svg-icons/constant-burn.svg';


  constructor() {
    this.translate.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe((params: LangChangeEvent) => {
        this.currentLanguage = params.lang;
      });

    effect(() => {
      this.dataService.widgetBalanceData();
      const step = this.dataService.balanceDataEVM?.currentStep ?? 0;
      const currentStore = this.dataService.tokenomics?.[step];
      this.salePrice = currentStore?.tokenUSDT ?? 0;
    });
  }
  trackExternalLink(url: string, name: string): void {
    this.pixelService.trackPageClick(url, name);
  }
}

